import React from 'react'
import {Col, Row, ActionSheet, ActionSheetButton} from 'react-onsenui'
import Loader from 'react-loader-spinner';

import {OPEN_EXTERNAL_LINK} from "../../../modules/variable/common_variable";
import firebase from "firebase/app";
import 'firebase/database';
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";

import {CHECK_FINE_DUST_LEVEL, CHECK_WEATHER_LEVEL, CHECK_TIME} from "../../../modules/variable/common_variable";
import _ from "underscore";

class WeatherCard extends React.Component {
    constructor(props) {
        super(props);

        let savedLocal = {code: 'seoul', name: '서울'};
        if(localStorage.getItem('savedLocal')){
            try {
                savedLocal = JSON.parse(localStorage.getItem('savedLocal'));
            } catch (e) {
                console.error(e);
            }
        }

        this.state = {
            weather: {isLoading: true, tab: 'current', local: savedLocal, data: null, current: null},
            iframeActionSheet: {open: false, frameUrl: null, siteName: ''},
            changeLocalActionSheet: {open: false, codeName: [{"code":"busan","name":"부산"},{"code":"chungbuk","name":"충북"},{"code":"chungnam","name":"충남"},{"code":"daegu","name":"대구"},{"code":"daejeon","name":"대전"},{"code":"gangwon","name":"강원"},{"code":"gwangju","name":"광주"},{"code":"gyeongbuk","name":"경북"},{"code":"gyeonggi","name":"경기"},{"code":"gyeongnam","name":"경남"},{"code":"incheon","name":"인천"},{"code":"jeju","name":"제주"},{"code":"jeonbuk","name":"전북"},{"code":"jeonnam","name":"전남"},{"code":"sejong","name":"세종"},{"code":"seoul","name":"서울"},{"code":"ulsan","name":"울산"}]
            }
        };
    }

    componentDidMount(){
        if(this.props.userInfo.isSignedIn){
            this.getWeatherInformation(this.state.weather.local.code);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(!this.props.userInfo.isSignedIn && nextProps.userInfo.isSignedIn){
            this.getWeatherInformation(this.state.weather.local.code);
        }
    }

    parseWeatherInformation = (localCode, data) => {
        const lwd = data.weather[localCode];
        const lwfd = data.weatherForecast[localCode];

        let weatherDate = "";
        try {
            weatherDate = lwd[0].baseDate.toString().substring(6, 8) + '일 ' + lwd[0].baseTime.toString().substring(0, 2) + ':' + lwd[0].baseTime.toString().substring(2, 4);
        } catch (e) {
            console.error(e);
            weatherDate = "ERROR";
        }
        let weatherJson = {date: weatherDate};
        for(let i = 0; i < lwd.length; i ++){
            weatherJson[lwd[i].category] = lwd[i].obsrValue;
        }
        for(let i = 0; i < lwfd.length; i ++){
            if(!weatherJson[lwfd[i].category]){
                weatherJson[lwfd[i].category] = lwfd[i].fcstValue;
            }
        }

        let weatherStatus;
        try {
            weatherStatus = CHECK_WEATHER_LEVEL(weatherJson.SKY, weatherJson.PTY);
        } catch (e) {
            weatherStatus =  {image: "sunny", name: "ERROR"};
        }

        weatherJson.status = weatherStatus;

        let ldd = 0;
        let findDustDate = "";
        let pm10 = 0;
        let pm25 = 0;
        let fineDustStatus = 5;
        try {
            ldd = new Date(data.pm10.dataTime);
            findDustDate = ldd.getDate() + '일 ' + CHECK_TIME(ldd.getHours()) + ':' + CHECK_TIME(ldd.getMinutes());
            pm10 = Number(data.pm10[localCode]);
            pm25 = Number(data.pm25[localCode]);
            fineDustStatus = CHECK_FINE_DUST_LEVEL(pm10, pm25);
        } catch (e) {
            console.error(e);
            findDustDate = "ERROR";
            pm10 = 0;
            pm25 = 0;
            fineDustStatus = 5;
        }

        let findDustJson = {date: findDustDate, pm10: pm10, pm25: pm25, status: fineDustStatus};
        let current =  {weather: weatherJson, findDust: findDustJson};

        const local = _.findWhere(this.state.changeLocalActionSheet.codeName, {code: localCode});
        localStorage.setItem('savedLocal', JSON.stringify(local));
        this.setState({weather: {...this.state.weather, current: current, data: data, local: local, isLoading: false}});
    };

    getWeatherInformation = (localCode) => {
        this.setState({weather: {...this.state.weather, isLoading: true}});
        let data = this.state.weather.data;
        if(!data) {
            firebase.database().ref('/information').once('value').then((snapshot) => {
                if (snapshot.exists()) {
                    data = snapshot.val();
                    this.parseWeatherInformation(localCode, data);
                }
            });
        }else{
            this.parseWeatherInformation(localCode, data);
        }
    };

    changeTabBarTarget = (name) => {
        this.setState({weather: {...this.state.weather, tab: name}});
    };

    showForecast = (type, open) => {
        const siteName = type === 'WEATHER' ? '기상청 날씨누리' : '우리동네 대기정보' ;
        const frameUrl = type === 'WEATHER' ? 'https://m.kma.go.kr/m/nation/forecast.jsp?ampm=1' : 'http://m.airkorea.or.kr';
        const backgroundColor = type === 'WEATHER' ? '#FFFFFF' : '#00000000' ;

        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: open, frameUrl: null, siteName: siteName}});
            if(open){
                const message = JSON.stringify({'type': 'OPEN_LINK_IN_FRAME', 'url': frameUrl, 'header': 56, 'footer': 52, 'backgroundColor': backgroundColor});
                setTimeout(() => {
                    window.postMessage(message, "*");
                }, 500)
            }else{
                const message = JSON.stringify({'type': 'HIDE_LINK_IN_FRAME'});
                window.postMessage(message, "*");
            }
        }else{
            OPEN_EXTERNAL_LINK(frameUrl);
            //this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: open, frameUrl: frameUrl, siteName: siteName}});
        }
    };

    selectLocal = (localCode) => {
        this.setState({changeLocalActionSheet: {...this.state.changeLocalActionSheet, open: false}});
        this.getWeatherInformation(localCode);
    };

    render() {
        const w = this.state.weather;

        return (
            <div className="home-weather-card-wrapper">
                <div className="list-header list-header--material home-weather-card-header">
                    <strong>{w.local.name}</strong> 기상 정보 <small>{!w.isLoading ? "(" + w.current.weather.date + " 발표)" : ''}</small>
                    <button className="button button--material--flat" onClick={() => this.setState({changeLocalActionSheet: {...this.state.changeLocalActionSheet, open :true}})}>지역 변경</button>
                </div>
                {/*<div className="tabbar tabbar--top tabbar--material">
                    <label className="tabbar__item tabbar--material__item">
                        <input type="radio" name="weather-tab" onChange={() => this.changeTabBarTarget('current')} checked={this.state.weather.tab === 'current' ? 'checked' : ''}/>
                        <button className="tabbar__button tabbar--material__button">
                            현재
                        </button>
                    </label>
                    <label className="tabbar__item tabbar--material__item">
                        <input type="radio" name="weather-tab" onChange={() => this.changeTabBarTarget('forecast')} checked={this.state.weather.tab === 'forecast' ? 'checked' : ''}/>
                        <button className="tabbar__button tabbar--material__button">
                            예보
                        </button>
                    </label>
                </div>*/}

                {
                    !w.isLoading ?
                        <Row>
                            <Col width={'50%'}>
                                <ul className="list--material list home-weather-card">
                                    <li className="list-header list-header--material">날씨</li>
                                    <li className="list-item list-item--material">
                                        <div className="list-item__left list-item--material__left">
                                            <img className="list-item__thumbnail"
                                                 src={'/assets/image/weather/' + w.current.weather.status.image + '.svg'}
                                                 alt={w.current.weather.status.name}/>
                                        </div>
                                        <div className="list-item__center list-item--material__center">
                                            <div className="list-item__title">{w.current.weather.status.name}, {w.current.weather.T1H}도</div>
                                            <div className="list-item__subtitle">습도: {w.current.weather.REH}%</div>
                                            <div className="list-item__subtitle">풍속: {w.current.weather.WSD}m/s</div>
                                        </div>
                                    </li>
                                    <li className="list-item list--inset__item list-item--chevron home-weather-show-forecast" onClick={() => this.showForecast('WEATHER', true)}>
                                        <div className="list-item__center">날씨 예보</div>
                                    </li>
                                </ul>
                            </Col>
                            <Col width={'50%'}>
                                <ul className="list--material list home-weather-card">
                                    <li className="list-header list-header--material">미세먼지 <small>(출처: 에어코리아)</small></li>
                                    <li className="list-item list-item--material">
                                        <div className="list-item__left list-item--material__left">
                                            <img className="list-item__thumbnail"
                                                 src={'/assets/image/weather/fine_dust_' + w.current.findDust.status.level + '.svg'}
                                                 alt={w.current.findDust.status.name}/>
                                        </div>
                                        <div className="list-item__center list-item--material__center">
                                            <div className="list-item__title">{w.current.findDust.status.name}</div>
                                            <div className="list-item__subtitle">미세: {w.current.findDust.pm10}㎍/m³</div>
                                            <div className="list-item__subtitle">초미세: {w.current.findDust.pm25}㎍/m³</div>
                                        </div>
                                    </li>
                                    <li className="list-item list--inset__item list-item--chevron home-weather-show-forecast" onClick={() => this.showForecast('FINE_DUST', true)}>
                                        <div className="list-item__center">미세먼지 예보</div>
                                    </li>
                                </ul>
                            </Col>
                            <Col width={'100%'}>
                                <div style={{padding: '4px 16px 0px 16px', fontSize: '10px'}}>
                                    ※ 미세먼지 데이터는 실시간 관측된 자료이며 측정소 현지 사정이나 데이터의 수신상태에 따라 미수신될 수 있습니다.
                                </div>
                            </Col>
                        </Row>
                        :
                        <ul className="list--material list" style={{width: '100%'}}>
                            <li className="list-item list-item--material">
                                <div className="list-item__center list-item--material__center">
                                    <div className="text-center" style={{width: '100%'}}>
                                        <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                                    </div>
                                </div>
                            </li>
                        </ul>
                }

                {
                    this.state.iframeActionSheet.open ?
                        <ActionSheet className="iframe-action-sheet" isOpen={this.state.iframeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} isCancelable={true} title={'이하 정보는 ' + this.state.iframeActionSheet.siteName  +  ' 사이트입니다.'}>
                            <iframe id="iframe-action-sheet" title="iframe-action-sheet" src={this.state.iframeActionSheet.frameUrl}></iframe>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.showForecast(null, false)} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

                {
                    this.state.changeLocalActionSheet.open ?
                        <ActionSheet className="weather-local-change-action-sheet" isOpen={this.state.changeLocalActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({changeLocalActionSheet: {...this.state.changeLocalActionSheet, open: false}})} isCancelable={true} title={"지역 변경"}>
                            {
                                this.state.changeLocalActionSheet.codeName.map((element, i) => {
                                  return (
                                      <ActionSheetButton key={['local', element.code, i].join('-')} class={this.state.weather.local.code === element.code ? 'weather-local-button weather-local-change-selected' : 'weather-local-button'} modifier={'material'} onClick={() => this.selectLocal(element.code)}>{element.name}<small>{this.state.weather.local.code === element.code ? ' (선택됨)' : ''}</small></ActionSheetButton>
                                  )
                                })
                            }
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({changeLocalActionSheet: {...this.state.changeLocalActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>지역 변경 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }
            </div>
        )
    }
}

const mapStateToProps = ({user}) => ({
    userInfo: user.userInfo,
});

export default withRouter(connect(
    mapStateToProps
)(WeatherCard))

